module.exports = __webpack_public_path__ + "img/img_banner_xxanquanpeix.b2cde805.png";